// Os 5 modelos de partida da marca d'agua. Cada um e um WatermarkDesign
// completo: o usuario escolhe na galeria e edita a partir dele.
const BAND_OFF = Object.freeze({
    enabled: false,
    color: "#111827",
    text: "",
    textColor: "#ffffff",
    size: 0.12,
});
const ASSINATURA = {
    preset: "assinatura",
    topBand: BAND_OFF,
    bottomBand: BAND_OFF,
    photo: { background: "#ffffff", fit: "cover" },
    layers: [
        {
            kind: "logo",
            id: "logo",
            box: { x: 0.76, y: 0.8, w: 0.2, h: 0.16 },
            rotation: 0,
            opacity: 0.9,
        },
        {
            kind: "contacts",
            id: "assinatura",
            box: { x: 0.04, y: 0.89, w: 0.42, h: 0.07 },
            rotation: 0,
            text: "@suamarca",
            color: "#ffffff",
            background: "#111827",
        },
    ],
};
const CARTAZ = {
    preset: "cartaz",
    topBand: {
        enabled: true,
        color: "#dc2626",
        text: "OFERTA DO DIA",
        textColor: "#ffffff",
        size: 0.12,
    },
    bottomBand: {
        enabled: true,
        color: "#facc15",
        text: "{price}",
        textColor: "#111827",
        size: 0.18,
    },
    photo: { background: "#ffffff", fit: "contain" },
    layers: [
        {
            kind: "badge",
            id: "desconto",
            box: { x: 0.72, y: 0.15, w: 0.24, h: 0.24 },
            rotation: 0,
            text: "-{discountPercent}",
            color: "#dc2626",
            textColor: "#ffffff",
            shape: "circle",
        },
        {
            kind: "text",
            id: "preco-antigo",
            box: { x: 0.04, y: 0.74, w: 0.4, h: 0.06 },
            rotation: 0,
            text: "de {originalPrice}",
            color: "#4b5563",
            background: null,
            align: "left",
            bold: false,
        },
        {
            kind: "logo",
            id: "logo",
            box: { x: 0.04, y: 0.15, w: 0.18, h: 0.12 },
            rotation: 0,
            opacity: 1,
        },
    ],
};
const FITA = {
    preset: "fita",
    topBand: BAND_OFF,
    bottomBand: BAND_OFF,
    photo: { background: "#ffffff", fit: "cover" },
    layers: [
        {
            kind: "badge",
            id: "fita",
            box: { x: 0.0, y: 0.08, w: 0.56, h: 0.1 },
            rotation: -20,
            text: "{discountPercent} OFF",
            color: "#16a34a",
            textColor: "#ffffff",
            shape: "ribbon",
        },
        {
            kind: "badge",
            id: "cupom",
            box: { x: 0.52, y: 0.84, w: 0.44, h: 0.1 },
            rotation: -6,
            text: "CUPOM {coupon}",
            color: "#111827",
            textColor: "#facc15",
            shape: "pill",
        },
        {
            kind: "logo",
            id: "logo",
            box: { x: 0.8, y: 0.04, w: 0.16, h: 0.12 },
            rotation: 0,
            opacity: 0.95,
        },
    ],
};
const ETIQUETA = {
    preset: "etiqueta",
    topBand: BAND_OFF,
    bottomBand: { enabled: true, color: "#ffffff", text: "{title}", textColor: "#111827", size: 0.2 },
    photo: { background: "#f4f4f5", fit: "contain" },
    layers: [
        {
            kind: "badge",
            id: "preco",
            box: { x: 0.6, y: 0.64, w: 0.36, h: 0.12 },
            rotation: 0,
            text: "{price}",
            color: "#15803d",
            textColor: "#ffffff",
            shape: "pill",
        },
        {
            kind: "badge",
            id: "desconto",
            box: { x: 0.04, y: 0.04, w: 0.2, h: 0.08 },
            rotation: 0,
            text: "-{discountPercent}",
            color: "#dc2626",
            textColor: "#ffffff",
            shape: "pill",
        },
        {
            kind: "logo",
            id: "logo",
            box: { x: 0.8, y: 0.04, w: 0.16, h: 0.12 },
            rotation: 0,
            opacity: 1,
        },
    ],
};
const VITRINE = {
    preset: "vitrine",
    topBand: { enabled: true, color: "#0f172a", text: "Sua Marca", textColor: "#ffffff", size: 0.12 },
    bottomBand: {
        enabled: true,
        color: "#0f172a",
        text: "t.me/suamarca  |  @suamarca",
        textColor: "#e2e8f0",
        size: 0.1,
    },
    photo: { background: "#ffffff", fit: "contain" },
    layers: [
        {
            kind: "logo",
            id: "logo",
            box: { x: 0.03, y: 0.015, w: 0.12, h: 0.09 },
            rotation: 0,
            opacity: 1,
        },
        {
            kind: "badge",
            id: "preco",
            box: { x: 0.64, y: 0.72, w: 0.32, h: 0.1 },
            rotation: 0,
            text: "{price}",
            color: "#f97316",
            textColor: "#ffffff",
            shape: "pill",
        },
    ],
};
export const WATERMARK_PRESETS = Object.freeze([
    {
        id: "assinatura",
        name: "Assinatura",
        description: "Logo discreto no canto e seu @ embaixo. Não cobre o produto.",
        design: ASSINATURA,
    },
    {
        id: "cartaz",
        name: "Cartaz",
        description: "Faixa de oferta no topo, selo de desconto e preço grande na base.",
        design: CARTAZ,
    },
    {
        id: "fita",
        name: "Fita",
        description: "Fita inclinada com o desconto e selo de cupom.",
        design: FITA,
    },
    {
        id: "etiqueta",
        name: "Etiqueta",
        description: "Cartão de produto com nome embaixo e preço em destaque.",
        design: ETIQUETA,
    },
    {
        id: "vitrine",
        name: "Vitrine",
        description: "Sua marca no topo e contatos na faixa de baixo.",
        design: VITRINE,
    },
]);
export const DEFAULT_WATERMARK_PRESET = "assinatura";
export function findWatermarkPreset(id) {
    return WATERMARK_PRESETS.find((preset) => preset.id === id);
}
/** Design inicial de um modelo (o padrao quando o id nao existe). */
export function presetDesign(id) {
    return (findWatermarkPreset(id) ?? findWatermarkPreset(DEFAULT_WATERMARK_PRESET)).design;
}
/** Dados de exemplo usados na previa do painel. */
export const WATERMARK_SAMPLE_DATA = Object.freeze({
    title: "Fone Bluetooth com cancelamento de ruído",
    price: "R$ 129,90",
    originalPrice: "R$ 199,90",
    discountPercent: "35%",
    coupon: "OFERTA10",
});
//# sourceMappingURL=presets.js.map